import produce from 'immer';
import {
  types,
  ConfigurationState,
  ConfigActionTypes,
  GetConfigAsyncSuccess,
  GetConfigAsyncError,
  GetConfigAsyncPending
} from './types';

// Actions
export const actions = {
  getConfig: (payload: { configurationId: string }): ConfigActionTypes => ({
    type: types.GET_CONFIG_ASYNC.REQUEST,
    payload
  })
};

// Initial State
export const initialState: ConfigurationState = {
  configuration: null,
  loading: false,
  error: undefined
};

// Reducer
export const reducer = (state: ConfigurationState = initialState, action: ConfigActionTypes): ConfigurationState => {
  return produce(state, draft => {
    switch (action.type) {
      case types.GET_CONFIG_ASYNC.SUCCESS:
        draft.configuration = (action as GetConfigAsyncSuccess).payload;
        break;
      case types.GET_CONFIG_ASYNC.ERROR:
        draft.error = (action as GetConfigAsyncError).payload;
        break;
      case types.GET_CONFIG_ASYNC.PENDING:
        draft.loading = (action as GetConfigAsyncPending).payload;
        break;
      default:
    }
  });
};
